import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Cards1.module.scss'
import styles2 from './../style/MoskitnieSistemyPreimushestva.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'
import FeedbackForm from './FeedbackForm'

class MoskitnieSistemyPreimushestva extends React.Component {
  
  constructor(props) {
    super(props)

    this.state = {
      show_feedback: false
    }
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { list, title, rtext, text } = this.props,
    { show_feedback } = this.state

    return (
      <section className={`${styles.section} ${styles.bottom}`}>
        <Container>
          {title != `` &&
            <WhiteBlockTitle
              title={title}
              text={rtext}
              className={styles.title}
            />
          }
          <div className={styles2.text}>{text}</div>
          <div className={`${styles.list} ${styles[`grid-4`]}`}>
            {list.map( ( elm, k ) => {
              if(elm?.image != '') return (
                <div className={`${styles.block} ${styles2.card}`}>
                  <Image className={styles2.bgimage} src={elm?.image} alt={`Подобрать сетку`} width={386} height={285} />
                  <div className={styles2.card_content}>
                    <div className={styles2.b_title} dangerouslySetInnerHTML={{__html: elm?.name}} />
                    <div className={styles2.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                    <GreenButton
                      text={`Подобрать сетку`}
                      width={247}
                      action={() => this.showFeedback()}
                      className={styles.button}
                    />
                  </div>
                </div>
              )
              return (
                <div className={`${styles.block} ${styles[`bg-1`]}`}>
                  <div className={styles.b_title_2}>
                    <div className={styles.b_icon}>
                      <Image src={elm?.icon} width={21} height={21} alt={elm?.name} />
                    </div>
                    <div className={styles.b_title_sep} />
                    <div>{this.formatSlideNumber(k)}</div>
                  </div>
                  <div className={styles.b_title_t_2} dangerouslySetInnerHTML={{__html: elm?.name}} />
                  <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                </div>
              )
            })}
          </div>
        </Container>
        <FeedbackForm
          title={`Подобрать сетку`}
          text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
          btn={`Отправить`}
          data={[]}
          show={show_feedback}
          handleClose={() => this.closeFeedback()}
        />
      </section>
    )
  }
}

MoskitnieSistemyPreimushestva.propTypes = {
  list: PropTypes.array,
  title: PropTypes.string,
  rtext: PropTypes.string,
  text: PropTypes.string
}

MoskitnieSistemyPreimushestva.defaultProps = {
  list: [],
  title: ``,
  rtext: ``,
  text: ``
}

export default MoskitnieSistemyPreimushestva